module.exports = __webpack_public_path__ + "static/media/pr.563200c5.svg";